
import { Injectable, OnInit } from '@angular/core';
import { RequestService } from './request.service';
import { IConfirmationCodeResponse } from '../models/response';


@Injectable()
export class CodeService implements OnInit {

    constructor(
        protected _requestService: RequestService
    ) {  }

    ngOnInit() { }

    VerifyCodeControl(email, phone, code: string) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/verifyConfirmationCode',
                { "email": email, "numero": phone, "codeInserted": code+"" },
                (data: IConfirmationCodeResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null)
        })
    }

    SendCodeRequest(email, cellulare, source) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/sendConfirmationCode',
                { "email": email, "numero": cellulare, "source": source },
                (data: IConfirmationCodeResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)

        })
    }
    SendCodeOtp(email, cellulare ,tokenid, username) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/sendOtpCode',
                { "email": email, "numero": cellulare,"tokenid": tokenid,
                "username": username},
                (data: IConfirmationCodeResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText });
                },
                null,
                false,
                null)

        })
    }
    VerifyCodeOtp(email, phone, code: string,tokenid, username) {
        return new Promise((resolve, reject) => {
            this._requestService.makeRequest('rest/internal/action/verifyMfaInSms',
                { "email": email, "numero": phone, "otpCode": code+"" ,"tokenid": tokenid,
                "username": username},
                (data: IConfirmationCodeResponse) => {
                    resolve(data);
                }, (error) => {
                    reject({ type: "SERVER", content: error.statusText })
                },
                null,
                false,
                null)
        })
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/services/code.service.ts